interface ApiResponseError {
  response?: {
    data?: {
      errorCode?: string
      code?: string
    }
  }
}

export const ERROR_CODE_TRANSLATION_KEY_MAP: Record<string, string> = {
  PHONE_VERIFICATION_CODE_INVALID: 'HADES_100_WRONG_PHONE_VERIFICATION_CODE',
  PHONE_VERIFICATION_NOT_INITIATED: 'HADES_101_EXPIRED_PHONE_VERIFICATION_CODE',
} as const

export const getErrorTranslationKey = (error: unknown) => {
  const errorCode = getErrorCodeFromApiError(error).toLowerCase()

  if (isCustomErrorMap(errorCode)) {
    return errorCode
  }

  return `api_errors_${errorCode}`
}

export const getErrorCodeFromApiError = (error: unknown) => {
  if (isApiResponseError(error)) {
    return error.response?.data?.errorCode || error.response?.data?.code || 'generic'
  } else {
    return 'generic'
  }
}

function isApiResponseError(error: unknown): error is ApiResponseError {
  if (error && typeof error === 'object') {
    const errorData = (error as ApiResponseError)?.response?.data

    return typeof errorData === 'object'
  }
  return false
}

export const isCustomErrorMap = (errorCode: string) => {
  return !!ERROR_CODE_TRANSLATION_KEY_MAP[errorCode]
}
